import React from "react";

// ASSETS
import PersonPlaceholder from "assets/img/PersonPlaceholder.png";

// STYLES
import {
  PersonnelCardContainer,
  PersonnelCardImage,
  PersonnelCardTextContainer,
  TitleWrapper,
  TextWrapper,
} from "./PersonnelCardStyled";

// LIBRARIES

// MISC
import { IProps, PersonnelCardType } from "./PersonnelCardModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";

// REDUX
import {
  accessibilityBiggerLineHeightSelector,
  accessibilityBiggerTextSelector,
  accessibilityBiggerLetterSpacingSelector,
} from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import { useSelector } from "react-redux";

const PersonnelCard = (props: IProps) => {
  // PROPERTIES
  const {
    image = "",
    fullName = "",
    occupation = "-",
    type = PersonnelCardType.Adaptable,
  } = props;

  // LIBRARY CONSTANTS

  // STATE CONSTANTS
  const accessibilityBiggerText: boolean = useSelector(
    accessibilityBiggerTextSelector
  );
  const accessibilityBiggerLineHeight: boolean = useSelector(
    accessibilityBiggerLineHeightSelector
  );
  const accessibilityBiggerLetterSpacing: boolean = useSelector(
    accessibilityBiggerLetterSpacingSelector
  );

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <PersonnelCardContainer>
      <PersonnelCardImage type={type} src={image} alt="Personnel Image" />
      <PersonnelCardTextContainer>
        <TitleWrapper>
          <CustomText
            text={fullName}
            type={TextType.H4}
            color={COLORS.Cultured}
          />
        </TitleWrapper>
        <TextWrapper
          accessibilityBiggerText={accessibilityBiggerText}
          accessibilityBiggerLineHeight={accessibilityBiggerLineHeight}
          accessibilityBiggerLetterSpacing={accessibilityBiggerLetterSpacing}
        >
          {occupation}
        </TextWrapper>
      </PersonnelCardTextContainer>
    </PersonnelCardContainer>
  );
};

export default PersonnelCard;
